export const isLocalhost = () => window.location.hostname === 'localhost' || window.location.hostname === 'devtest.sales.ai.dev.dynamics.com';
